export default __webpack_public_path__ + "static/media/yoga.e817b234.svg";